import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 1.5rem;
  background: ${props => props.theme.cards.primary};
  backdrop-filter: ${props => props.theme.cards.backdropFilter};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
  border: 1px solid ${props => props.theme.cards.border};
  width: 100%;
  overflow: hidden;

  > aside {
    
    > h6 {
      margin: 0px;
      font-size: 0.85rem;
      text-decoration: none;
      color: ${props => props.theme.colors.muted};
      font-weight: 600;
      margin-bottom: 0.25rem;
    }

    > h4 {
      font-size: 3vw;
      color: ${props => props.theme.colors.white};
      font-weight: 800;

      @media (max-width: 768px) {
        font-size: 1.5rem;
      }
    }
  }

  > main {
    //padding: 0.75rem;
    border-radius: ${props => props.theme.radius.primary};
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    right: -22px;
    top: 46px;

    @media (max-width: 768px) {
      right: 0px;
      top: 10px;
    }

    > svg {
      font-size: 1.5vw;

      @media (max-width: 768px) {
        width: 77px;
        right: 1rem;
      }
    }
  }
`;
